import { render, staticRenderFns } from "./bottomNav.vue?vue&type=template&id=4b4a2228&scoped=true"
var script = {}
import style0 from "../assets/bottom.css?vue&type=style&index=0&id=4b4a2228&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4a2228",
  null
  
)

export default component.exports